import React, { useEffect, useRef, useState } from "react";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";
import ReactSelect from "react-select";
import BXPDetails from "../AddBXP/BXPDetails";
import WorkSamples from "../AddBXP/WorkSamples";
import PricingTerms from "../AddBXP/PricingTerms";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { scrollToTop } from "../../../../../CloudStorage/CommonFunction";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";

const IAddBXP = ({ formData, setFormData, nextPage, previousPage }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("BXPDetails");
  const [modalOpen, setModalOpen] = useState(false);
  const [updateindex, setUpdateindex] = useState(null);
  const [bxpDataList, setbxpDataList] = useState(
    Array.isArray(formData?.bxp) ? formData.bxp : [],
  );
  const [bxpData, setbxpData] = useState(
    Array.isArray(formData?.bxp) ? formData.bxp : [],
  );

  const openModal = () => {
    setModalOpen(true);
    setActiveTab("BXPDetails");
    setbxpData([]);
    setUpdateindex(null);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const modalStyle = {
    right: modalOpen ? "0" : "-50%",
  };
  useEffect(() => {
    scrollToTop();
  }, [activeTab]);

  useEffect(() => {
    setbxpDataList(formData?.bxp);
  }, [bxpData]);

  const deleteBxp = (index) => {
    setbxpData((prevData) => {
      const updatedBxpData = Array.isArray(prevData)
        ? prevData.filter((_, i) => i !== index)
        : [];
      return updatedBxpData;
    });

    setFormData((prevData) => ({
      ...prevData,
      bxp: Array.isArray(prevData.bxp)
        ? prevData.bxp.filter((_, i) => i !== index)
        : [],
    }));
  };

  const updateBxp = (index) => {
    setUpdateindex(index);
    setbxpData(formData?.bxp[index]);
    setModalOpen(true);
    setActiveTab("BXPDetails");
  };

  useEffect(() => {
    setbxpData(Array.isArray(formData?.bxp) ? formData.bxp : []);
  }, [formData]);

  const modalRef = useRef(null);

  useEffect(() => {
    if (activeTab && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [activeTab]);

  const handleNextClick = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    nextPage();
    setLoading(false);
  };
  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalOpen]);
  return (
    <div>
      <div
        ref={modalRef}
         className="add-education-modal add-bxp-modal add-overlay-modal-width active"
        style={modalStyle}
      >

        <div className={`modal-overlay-sec   ${modalOpen ? 'active' : ''}`}></div>
        <div className="modal-width">
          <div className="modal-head">
            <h3> {updateindex !== null ? "Edit" : "Add"} packaged service</h3>
            <button onClick={closeModal} className="btn close-modal-btn">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                alt="Close"
              />
            </button>
          </div>

          <div className="tab-bxp">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={
                    activeTab == "BXPDetails"
                      ? "active"
                      : activeTab == "WorkSamples"
                        ? "active"
                        : activeTab == "PricingTerms"
                          ? "active"
                          : ""
                  }
                >
                  <span>1</span> Service Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab == "WorkSamples"
                      ? "active"
                      : activeTab == "PricingTerms"
                        ? "active"
                        : ""
                  }
                >
                  <span>2</span> Work Samples
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab == "PricingTerms" ? "active" : ""}
                >
                  <span>3</span> Pricing & Terms
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="BXPDetails">
                <BXPDetails
                  updateindex={updateindex}
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                />
              </TabPane>
              <TabPane tabId="WorkSamples">
                <WorkSamples
                  updateindex={updateindex}
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                />
              </TabPane>
              <TabPane tabId="PricingTerms">
                <PricingTerms
                  updateindex={updateindex}
                  bxpData={bxpData}
                  setbxpData={setbxpData}
                  setActiveTab={setActiveTab}
                  setFormData={setFormData}
                  setModalOpen={setModalOpen}
                />
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>

      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            05/07 <span>One Time Services (OTS)</span>
          </h6>
          <h2>Add your Packaged based service</h2>
          <p>Specify the details of your packaged-based service to ensure clear offerings and a tailored customer experience</p>
        </div>
        <div className="col-lg-6   about-right">
          <div className="add-skip">
            <h6>Add Packaged service</h6>
            <button className="cart-btn" onClick={nextPage}>
              Skip for now
            </button>
          </div>
          {Array.isArray(bxpDataList) &&
            bxpDataList.map((item, index) => (
              <div className="row add-wrapper" key={index}>
                <div className="col-md-6">
                  <div className="add-education-wrapper1">
                    <div className="edu-img">
                      <img src={item.cover} className="w-100" alt="Cover" />
                    </div>

                    <div className="add-button-education">
                      <button onClick={() => deleteBxp(index)}>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`}
                          alt=""
                        />
                      </button>
                      <button onClick={() => updateBxp(index)}>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                          alt=""
                        />
                      </button>
                    </div>
                    <div>
                      <h2>
                        {decodeHtml(item.title).substring(0, 16)}
                        {decodeHtml(item.title).length > 16 ? "..." : ""}
                      </h2>
                      <h2>$: {formatNumberWithCommas(item.price)}</h2>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <button className="add-education-btn add-bxp-btn" onClick={openModal}>
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
              alt="Add"
            />
            Add packaged service
          </button>
        </div>
      </div>

      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt="Back"
          />
          Back
        </button>
        <button
          type="button"
          onClick={() => handleNextClick()}
          className="next-button"
        >
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IAddBXP;
